import React from "react";
import PropTypes from "prop-types";
import { MultiSelect } from "../filters/MultiSelect";

const ColumnSelector = ({
    headers,
    onColumnVisibilityChange,
    defaultSelected,
}) => {
    const options = headers
        .filter(
            (header) => !["tier", "client_name", "rank"].includes(header.key)
        )
        .map((header) => ({
            id: header.key,
            label: header.name,
        }));

    const defaultSelectedOptions = options.filter((option) =>
        defaultSelected?.includes(option.id)
    );

    const handleChange = (selectedOptions) => {
        const selectedKeys = selectedOptions.map((option) => option.id);
        onColumnVisibilityChange(selectedKeys);
    };

    return (
        <MultiSelect
            options={options}
            onChange={handleChange}
            defaultSelected={defaultSelectedOptions}
            showSearch={true}
            itemText="column"
        />
    );
};

ColumnSelector.propTypes = {
    headers: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })
    ).isRequired,
    onColumnVisibilityChange: PropTypes.func.isRequired,
    defaultSelected: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ColumnSelector;
